import { useState, useRef, useEffect } from 'react';

type ScrollDirection = 'up' | 'down' | null;

export const useScrollDirection = (ref: React.RefObject<HTMLElement>) => {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>(null);
  const lastScrollTop = useRef<number>(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!ref.current) return;

      const currentScrollTop = ref.current.scrollTop;

      if (currentScrollTop > lastScrollTop.current) {
        setScrollDirection('down');
      } else if (currentScrollTop < lastScrollTop.current) {
        setScrollDirection('up');
      }

      lastScrollTop.current = currentScrollTop;
    };

    const element = ref.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, [ref]);

  return { scrollDirection };
};
